import Cookies from "js-cookie";
import { getEnvConfig } from "helpers/environment-config";

export const getSessionCookie = async () => {
  const environment = await getEnvConfig("environment");
  const cookieName = `token-${environment}`;

    return Cookies.get(cookieName);
};
